export abstract class Constants {
     public static readonly LogoutReason_LOGOUT = 'LO';
     public static readonly LogoutReason_BROWSER_CLOSE = 'BC';
     public static readonly LogoutReason_NEW_SESSION = 'NS';
     public static readonly LogoutReason_INACTIVE = 'IA';
     public static readonly SESSION_CONTEXT = 'SessionContext';
     public static readonly AUTH_TOKEN = 'authToken';
     public static readonly CONNECT = 'connect';
     public static readonly POLL_INTERVAL = 20000;
}
